import React, {useState} from 'react';
import useOutsideClick from '../../../../hooks/useOutsideClick';
import {IAuditChecklistItem} from '../../../../resources/IChecklistAudit.resource';
import styles from './styles.module.scss';

const ArrowDownIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
        <path d="M13.0176 7.5542L8.99972 11.5721L4.98186 7.5542" stroke="black" strokeOpacity="0.4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);

interface IProps {
    checklists: IAuditChecklistItem[];
    selectedId: number | null;
    onSelect: (id: number) => void;
}

const SelectChecklist: React.FC<IProps> = ({checklists, selectedId, onSelect}) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);

    const handleToggle = () => setIsOpen((prev) => !prev);
    const handleClose = () => setIsOpen(false);

    const handleSelectItem = (id: number) => {
        onSelect(id);
        handleClose();
    };

    const selectedName = checklists.find((c) => c.id === selectedId)?.name ?? null;

    const ref = useOutsideClick(handleClose);

    return (
        <div className={styles.checklist} ref={ref}>
            <button
                className={styles.checklist__select}
                onClick={handleToggle}
                type="button"
            >
                {selectedName ? (
                    <span className={styles.checklist__value}>{selectedName}</span>
                ) : (
                    'Чекліст'
                )}
                <ArrowDownIcon />
            </button>
            {isOpen && (
                <div className={styles.checklist__list}>
                    {checklists.map((item) => (
                        <button
                            className={styles.checklist__item}
                            key={item.id}
                            type="button"
                            onClick={() => handleSelectItem(item.id)}
                        >
                            {item.name}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

export default SelectChecklist;
